import React from 'react'

const defaultStyle = {};
const styleWithNoBorder = {border: 'none'};
const CheckoutSectionBody = ({ children, hideBodyBorder }) => (
  <div
    className="card-body"
    style={hideBodyBorder ?  styleWithNoBorder : defaultStyle}
  >
    {children}
  </div>
)

export default CheckoutSectionBody


// WEBPACK FOOTER //
// ./src/Components/checkout/components/Layout/CheckoutSectionBody.jsx